const getPointsOptionsLimitedByAvailable = availablePoints => {
	let pointsOptions = []

	const maxPoints = 250000
	const pointsInterval = 500

	for (
		let i = pointsInterval;
		i <= (availablePoints || maxPoints);
		i += pointsInterval
	) {
		pointsOptions.push({
			value: i,
			label: `${Number(i).toLocaleString('pt-BR')} pontos`
		})
	}

	return pointsOptions
}

export { getPointsOptionsLimitedByAvailable }
